(function() {
    angular
        .module("app")
        .factory("historyService", historyService)

    historyService.$inject = ["$rootScope", "$http"]

    function historyService($rootScope, $http) {
        var service = {}
        var totalHistory = {}

        var getDeviceURL = function(deviceCategory) {
            if (deviceCategory === "Tracker") {
                return "/trackers/"
            }
            return "/message_boards/"
        }

        /**
            Get device history by date
            @param {string} deviceCategory
            @param {int}    deviceID
            @param {string} startDate
            @param {string} endDate
            @param {int}    page
            @param {int}    perPage
            @returns {*}
         **/
        service.getAllHistoryByDate = function(deviceCategory, deviceID, startDate, endDate, page, perPage) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + "/history?"
                    + "start_date=" + startDate
                    + "&end_date=" + endDate
                    + "&page=" + page
                    + "&perpage=" + perPage
            }).then(success, failure)

            function success(response) {
                totalHistory = response.headers("Total")
                return response.data
            }

            function failure(error) {
                console.error(error)
            }
        }

        service.getTelemetryHistory = function(deviceCategory, deviceID, startDate, endDate, page, perPage) {
            var deviceURLLastPath = "telemetry_message_boards"
            if (deviceCategory === "Tracker") {
                deviceURLLastPath = "telemetry_trackers"
            }
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + "/history/" + deviceURLLastPath + "?"
                    + "start_date=" + startDate
                    + "&end_date=" + endDate
                    + "&sort=updated_at"
                    + "&sort_direction=DESC"
                    + "&page=" + page
                    + "&perpage=" + perPage
            }).then(success, failure)

            function success(response) {
                totalHistory = response.headers("Total")
                return response.data
            }

            function failure(error) {
                console.error(error)
            }
        }

        service.getTelemetryHoursHistory = function(deviceID, startDate, endDate, quantity) {

            const deviceURLLastPath = "telemetry_solar_light_tower_hours"

            const success = (response) => {
                totalHistory = response.headers("Total")
                return response.data
            }

            const failure = (error) => {
                console.error(error)
            }

            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + getDeviceURL("Tracker") + deviceID + "/history/" + deviceURLLastPath + "?"
                    + "start_date=" + startDate
                    + "&end_date=" + endDate
                    + "&quantity=" + quantity
            }).then(success, failure)

        }

        /**
            Get device telemetry history
            @param {string} deviceCategory
            @param {int}    deviceID
            @param {string} startDate
            @param {string} endDate
            @param {string} sortDirection
            @param {int}    page
            @param {int}    perPage
            @returns {*}
         **/
        service.getGPSHistory = function(deviceCategory, deviceID, startDate, endDate, page, perPage) {
            var deviceURLLastPath = "telemetry_message_boards"
            if (deviceCategory === "Tracker") {
                deviceURLLastPath = "telemetry_trackers"
            }
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + "/history/gps/" + deviceURLLastPath + "?"
                    + "start_date=" + startDate
                    + "&end_date=" + endDate
                    + "&sort=updated_at"
                    + "&sort_direction=DESC"
                    + "&page=" + page
                    + "&perpage=" + perPage
            }).then(success, failure)

            function success(response) {
                totalHistory = response.headers("Total")
                return response.data
            }

            function failure(error) {
                console.error(error)
            }
        }

        /**
            Get device alert history
            @param {string} deviceCategory
            @param {int}    deviceID
            @param {string} startDate
            @param {string} endDate
            @param {int}    page
            @param {int}    perPage
            @returns {*}
         **/
        service.getAlertHistory = function(deviceCategory, deviceID, startDate, endDate, page, perPage) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + "/history/alerts?"
                    + "start_date=" + startDate
                    + "&end_date=" + endDate
                    + "&page=" + page
                    + "&perpage=" + perPage
            }).then(success, failure)

            function success(response) {
                totalHistory = response.headers("Total")
                return response.data
            }

            function failure(error) {
                console.error(error)
            }
        }

        /**
            Get history count
            @returns {*}
         **/
        service.getTotalHistory = function() {
            return totalHistory
        }

        service.exportTelemetry = (deviceCategory, deviceID, endDate, failure) => {

            const _success = (response) => {

                try {

                    if (response.data && response.data.size < 10) {
                        _failure({ data: { error: "No Telemetry available for the selected date range." }})
                        return
                    }

                    const url        = window.URL.createObjectURL(response.data)
                    const a          = document.createElement("a")
                    const header     = unescape(response.headers()["content-disposition"])
                    const startIndex = header.indexOf("filename=")

                    let filename = header.slice(startIndex + 9)

                    if (!filename || filename === "" || filename === "d" || filename === "d.zip") {
                        filename = "Telemetry-Export.zip"
                    }

                    a.style    = "display: none"
                    a.href     = url
                    a.download = filename

                    document.body.appendChild(a)
                    a.click()

                    document.body.removeChild(a)
                    window.URL.revokeObjectURL(url)

                } catch(error) {
                  _failure({ data: { error: error }})
                }
            }

            const _failure = (response) => {
                console.error(response)
                if (failure && response && response.data) {
                    const error = response.data.hasOwnProperty("error") ? response.data.error : response.data
                    failure(error)
                }
            }

            return $http({
                method:       "GET",
                url:          $rootScope.config.apiUrl + getDeviceURL(deviceCategory) + deviceID + "/history/export?" + "end_date=" + endDate,
                responseType: "blob"
            }).then(_success, _failure)
        }

        return service
    }
})()
